import {
  Box,
  Button,
  FormLabel,
  Stepper as MuiStepper,
  Paper,
  Step,
  StepContent,
  StepLabel,
  Typography,
  StepIcon,
  Grid
} from "@mui/material";
// import Grid from "@mui/material/Unstable_Grid2";
import PropTypes from "prop-types";
import { Fragment, useState } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CancelIcon from "@mui/icons-material/Cancel";

export default function Stepper(props) {
  const { item, errors = null, renderFields } = props;
  const [activeStep, setActiveStep] = useState(null);

  const switchAccordion = (step) => {
    if (step === activeStep) step = null;
    setActiveStep(step);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const getErrorCount = (step) => {
    let numErrors = 0;
    step.children.forEach((item) => {
      if (errors[item.name]) numErrors++;
    });
    return numErrors;
  };

  const getNumErrors = (step) => {
    if (item.showSubformErrorCount || 1 == 1) {
      //onst numCount = step.children.length;
      const numErrors = getErrorCount(step);
      //return "(" + (numCount - numErrors) + "/" + numCount + ")";
      if (numErrors === 1)
        return "(" + numErrors + " fehlende bzw. fehlerhafte Eingabe)";
      else return "(" + numErrors + " fehlende bzw. fehlerhafte Eingaben)";
    } else return <Fragment></Fragment>;
  };

  const getLabelProps = (step) => {
    if (item.showSubformErrorCount) {
      if (getErrorCount(step) > 0) return { error: true };
      else return null;
    }
    return null;
  };

  return (
    <Paper
      elevation={0}
      sx={{
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "#E6E6E6",
        backgroundColor: "rgba(128, 128, 128, 0.06)",
        height: "100%",
        width: "100%",
        pl: "10px",
        pr: "10px",
        pt: "4px",
        pb: "10px",
        margin: "0px",
      }}
    >
      <FormLabel filled={true}>{item.label}</FormLabel>
      <MuiStepper activeStep={activeStep} orientation="vertical">
        {item &&
          item.steps.map((step, index) => (
            <Step key={step.label}>
              <StepLabel
                {...getLabelProps(step)}
                StepIconComponent={(props) =>
                  getErrorCount(step) > 0 ? (
                    <CancelIcon {...props} sx={{ color: "red" }} />
                  ) : (
                    <StepIcon {...props} />
                  )
                }
              >
                <Typography
                  variant="title"
                  sx={{
                    cursor: "pointer",
                    color: getErrorCount(step) > 0 ? "red" : "",
                  }}
                  onClick={(e) => switchAccordion(index)}
                >
                  {step.label} {getNumErrors(step)}
                </Typography>
              </StepLabel>
              <StepContent sx={{ textAlign: "left" }}>
                {step.description && (
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="title" component="h1">
                        Hinweis
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography variant="body">{step.description}</Typography>
                    </AccordionDetails>
                  </Accordion>
                )}

                <Grid container="true" spacing={2} sx={{ mt: "10px" }}>
                  {renderFields(step.children)}
                </Grid>
                <Box sx={{ mb: 2 }}>
                  <div>
                    <Button
                      color="primary"
                      variant="text"
                      disabled={index === 0}
                      onClick={handleBack}
                      sx={{ mt: 1, mr: 1, textTransform: "none" }}
                    >
                      zurück
                    </Button>
                    <Button
                      color="primary"
                      disabled={index === item.steps.length - 1}
                      onClick={handleNext}
                      sx={{ mt: 1, mr: 1, textTransform: "none" }}
                    >
                      Weiter
                    </Button>
                  </div>
                </Box>
              </StepContent>
            </Step>
          ))}
      </MuiStepper>
    </Paper>
  );
}

Stepper.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  variant: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  renderFields: PropTypes.func,
  handleRemoveValues: PropTypes.func,
  validateForm: PropTypes.func,
};
